import { WithStyles, withStyles } from '@mui/styles';

import Header from './header';
import { muiStyles } from './styles';

export interface HeaderProps extends WithStyles<typeof muiStyles> {
}

export default withStyles(muiStyles)(Header);